import type { ReactNode } from 'react'
import { Search, SlidersHorizontal, Plus, Download } from 'lucide-react'
import { ViewToggle, type ViewMode } from './ViewToggle'

export interface ToolbarView { id: string; label: string }

/** List-view control strip (spec §6): view tabs · search · filter · sort · add · export · count. */
export function ListToolbar({
  views, activeView, onView,
  search, onSearch, searchPlaceholder = 'Search…',
  count, onAdd, addLabel = 'Add', onExport, onFilter, extra, viewMode, onViewMode,
}: {
  views?: ToolbarView[]; activeView?: string; onView?: (id: string) => void
  search?: string; onSearch?: (v: string) => void; searchPlaceholder?: string
  count?: number; onAdd?: () => void; addLabel?: string; onExport?: () => void
  onFilter?: () => void
  viewMode?: ViewMode; onViewMode?: (m: ViewMode) => void
  extra?: ReactNode
}) {
  return (
    <div className="toolbar">
      {views && views.length > 0 && (
        <div className="toolbar-views">
          {views.map((v) => (
            <button key={v.id} className={`toolbar-view${v.id === activeView ? ' active' : ''}`} onClick={() => onView?.(v.id)}>
              {v.label}
            </button>
          ))}
        </div>
      )}
      {onSearch && (
        <div className="toolbar-search">
          <Search size={15} />
          <input value={search ?? ''} placeholder={searchPlaceholder} onChange={(e) => onSearch(e.target.value)} />
        </div>
      )}
      {extra}
      <div className="toolbar-right">
        {count != null && <span className="toolbar-count">{count.toLocaleString()} records</span>}
        {viewMode && onViewMode && <ViewToggle mode={viewMode} onChange={onViewMode} />}
        {onFilter && <button className="toolbar-btn" onClick={onFilter}><SlidersHorizontal size={14} />Filter</button>}
        {onExport && <button className="toolbar-btn" onClick={onExport}><Download size={14} />Export</button>}
        {onAdd && <button className="toolbar-btn toolbar-btn--primary" onClick={onAdd}><Plus size={14} />{addLabel}</button>}
      </div>
    </div>
  )
}
